export default __webpack_public_path__ + "static/media/burgundyDoor.f8bfa33e.gif";